"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initBroadCastListener = void 0;
const eventManager_1 = require("./eventManager");
const setTokens_1 = require("../methods/setTokens");
const broadcastChannel_1 = require("./broadcastChannel");
const refreshToken_1 = require("../methods/refreshToken");
function initBroadCastListener() {
    const channel = broadcastChannel_1.getBroadcastChannel();
    if (!channel)
        return;
    channel.onmessage = (e) => {
        var _a;
        switch (e.data.action) {
            case 'logout':
                eventManager_1.emit('logout.success');
                break;
            case 'setTokens':
                setTokens_1.setTokens(e.data.payload.idToken, e.data.payload.accessToken, false, false); // adding forth false to prevent infinite loop
                break;
            case 'refreshStart':
                refreshToken_1.initOngoingRefresh();
                break;
            case 'refreshEnd':
                refreshToken_1.resolveOngoingRefresh((_a = e.data.payload) === null || _a === void 0 ? void 0 : _a.tokens);
                break;
        }
    };
}
exports.initBroadCastListener = initBroadCastListener;
